// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__dFMIe","col":"Table_col__2g1JW","fulfillmentStatus":"Table_fulfillmentStatus__2RipX","emailCol":"Table_emailCol__59A4A"};